var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-one"},[_c('div',{staticClass:"title-txt"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{staticClass:"title-ps"},[_vm._v("\n    "+_vm._s(_vm.psTxt)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }